<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-xl-8 no-padding">
        
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">All discussions</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                <div class="col-md-12 col-sm-12 ">

                    <!--<mat-form-field appearance="standard" style="width:100%">
      <mat-label>Search for discussions</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="" #input>
    </mat-form-field>-->
                    <div *ngIf="!isLoading" class="row" style="margin-bottom:10px">
                        <div class="col-xl-3 col-md-6 col-xs-6 col-sm-6" *ngFor="let category of discussionCategories " style="margin-bottom: 10px;">
                            <a (click)="applyCategoryFilter(category.code)" [ngStyle]="{'background-color': category.isActive ? category.active_background_color : category.inactive_background_color, 'color': category.isActive ? category.active_color : category.inactive_color, 'border-color': category.inactive_color }" style="width: 100%; font-size: 13px; height: 35px; margin-right: 20px; font-weight: inherit; color: #00A6B6;" class="btn btn-default">
                                {{category.name}}
                            </a>
                        </div>
                    </div>
                    <div class="form-floating" style="margin-bottom:20px">
                        <input type="text" class="form-control" id="floatingInputValueSubject" (keyup)="applyFilter($event)">
                        <label for="floatingInputValueSubject">Search for discussions</label>
                    </div>

                    



                    <div class="mat-elevation-z8">
                        <table mat-table [dataSource]="dataSource" matSort style="width:100%">

                            <!-- ID Column -->
                            <ng-container matColumnDef="discussion">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Find solutions, ask questions and connect with our community </th>
                                <td mat-cell *matCellDef="let row">
                                    <div class="row" style="margin-top:20px">
                                        <div class="col-xl-6" style="margin-bottom: 10px;">
                                            <span class="box-category">{{row.category}}</span>
                                        </div>
                                        <div class="col-xl-6 text-right" style="margin-bottom: 10px;">
                                            <span style="float: right;" class="text-muted float-lg-right">{{row.createdDate | date:'medium'}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12" style="padding-bottom: 10px; padding-top: 10px;">
                                        <b>{{row.title}}</b>
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 box-name" style="padding-bottom:20px">
                                        {{row.ownerName}}
                                    </div>
                                    <div class="col-md-12 col-sm-12 col-xs-12 box-icon" style="padding-bottom:20px">
                                        <div class="row">
                                            <div class="col-md-2 col-sm-2 col-xs-2 ">
                                                <i class="fa fa-eye"></i><span> {{row.viewsCount}}</span>
                                            </div>
                                            <div class="col-md-2 col-sm-2 col-xs-2 ">
                                                <i class="fa fa-comment"></i><span> {{row.answersCount}}</span>
                                            </div>
                                        </div>

                                    </div>
                                </td>
                            </ng-container>


                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr class="table_row" mat-row (click)="clickedRows(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="1">{{loadingMessage}}</td>
                            </tr>
                        </table>

                        <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of users"></mat-paginator>
                    </div>



                </div>
            </div>
        


    </div>
    <div class="col-xl-4" style="padding-right: 0px; padding-left: 30px;">
        <app-discussions-active-users></app-discussions-active-users>
    </div>
</div>
